import { layoutHeaderSlice } from "@/widgets/LayoutHeader/model/slice";
import { layoutSidebarSlice } from "@/widgets/LayoutSidebar/model/slice";
import { profileSidebarSlice } from "@/widgets/ProfileSidebar/model/slice";
import { compose } from "@reduxjs/toolkit";
import { Reducer } from "@reduxjs/toolkit";
import { injectReducer } from "redux-injectors";
import tablesSlice from "@/shared/ui/XadomTable/model/table/slice";
import xadomTableRowSlice from "@/shared/ui/XadomTable/model/row/slice";
/**
 * Redux 리듀서 타입:
 * 
 * 1. 정적 리듀서 (Static Reducers)
 *    - 앱 전체 생명주기 동안 유지
 *    - 초기 로딩 시 포함
 *    - 기본 상태 관리 담당
 * 
 * 2. 동적 리듀서 (Dynamic Reducers)
 *    - injectReducer()를 통해 실행 중 추가
 *    - 필요할 때만 로드
 * 
 * 분리 사유:
 * - 초기 번들 크기 최적화
 * - 앱 초기 로딩 성능 향상
 * - 리소스 효율적 관리
 */

export const staticReducers = {
    layoutHeader: layoutHeaderSlice.reducer,
    layoutSidebar: layoutSidebarSlice.reducer,
    profileSidebar: profileSidebarSlice.reducer,
    xadomTable: tablesSlice.reducer,
    xadomTableRow: xadomTableRowSlice.reducer,
};
    
export const injectReducers = (...reducerPairs: [string, Reducer][]) => {
    return (WrappedComponent: React.ComponentType<any>) => {
        const enhancers = reducerPairs.map(([key, reducer]) =>
            injectReducer({ key, reducer })
        );

        return compose(...enhancers)(WrappedComponent) as React.ComponentType<any>;
    };
};